import React from "react";
import { ChevronRight } from "lucide-react";

export default function SettingsItem({
  icon: Icon,
  title,
  subtitle,
  tone = "default", // "default" | "danger"
  onClick,
}) {
  const isDanger = tone === "danger";

  return (
    <button
      type="button"
      onClick={onClick}
      className={
        "p2-settings-item" + (isDanger ? " p2-settings-item--danger" : "")
      }
    >
      <div className="p2-settings-item-main">
        {Icon && (
          <div
            className={
              "p2-settings-item-icon" +
              (isDanger ? " p2-settings-item-icon--danger" : "")
            }
          >
            <Icon className="p2-settings-item-icon-svg" />
          </div>
        )}
        <div className="p2-settings-item-text">
          <span
            className={
              "p2-settings-item-title" +
              (isDanger ? " p2-settings-item-title--danger" : "")
            }
          >
            {title}
          </span>
          {subtitle && (
            <span className="p2-settings-item-subtitle">
              {subtitle}
            </span>
          )}
        </div>
      </div>

      <ChevronRight
        className={
          "p2-settings-item-chevron" +
          (isDanger ? " p2-settings-item-chevron--danger" : "")
        }
      />
    </button>
  );
}
